/**
 * Caution: Consider this file when using react-scripts
 *
 * You may delete this file and its occurrences from the project filesystem if you are using GatsbyJS or NextJS version
 */
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import WithLayout from "./WithLayout";
import PrivateRoute from "./PrivateRoute";

import {
  Main as MainLayout,
  Minimal as MinimalLayout,
  None as NoneLayout,
  DocsLayout,
} from "./layouts";

import {
  Account as AccountView,
  Communications as CommunicationsView,
  Credentials as CredentialsView,
  Contacts as ContactsView,
  ContinuingEducation as ContinuingEducationView,
  Dashboard as DashboardView,
  Documents as DocumentsView,
  Forms as FormsView,
  Protocols as ProtocolsView,
  SelfService as SelfServiceView,
  Login as LoginView,
  Safety as SafetyView,
  LoginTest as LoginTestView,
  NotFound as NotFoundView,
  Map as MapView,
  Protocols,
} from "./views";

//sessions
// import { Session } from "helpers";

const Routes = () => {
//   const session = React.useContext(Session.SessionContext);

  return (
    <Switch>
      <Route
      exact
        path="/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LoginView}
            layout={NoneLayout}
          />
        )}
      />
      <PrivateRoute
        path="/account"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={AccountView}
            layout={MainLayout}
          />
        )}
      />
      <PrivateRoute
        path="/communications"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={CommunicationsView}
            layout={MainLayout}
          />
        )}
      />
      <PrivateRoute
        path="/contacts"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={ContactsView}
            layout={MainLayout}
          />
        )}
      />
      <PrivateRoute
        path="/continuing_education"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={ContinuingEducationView}
            layout={MainLayout}
          />
        )}
      />           
      <PrivateRoute
        path="/credentials"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={CredentialsView}
            layout={MainLayout}
          />
        )}
      />           
      <PrivateRoute
        path="/dashboard"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={DashboardView}
            layout={MainLayout}
          />
        )}
      />
      <PrivateRoute
        path="/documents"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={DocumentsView}
            layout={MainLayout}
          />
        )}
      />
      <PrivateRoute
        path="/forms"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={FormsView}
            layout={MainLayout}
          />
        )}
      />         
      <Route
        path="/login"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LoginView}
            layout={NoneLayout}
          />
        )}
      />
      <Route
        path="/loginTest"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LoginTestView}
            layout={NoneLayout}
          />
        )}
      />
      <PrivateRoute
        path="/protocols"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={ProtocolsView}
            layout={MainLayout}
          />
        )}
      />
      <PrivateRoute
        path="/self_service"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={SelfServiceView}
            layout={MainLayout}
          />
        )}
      />                
      <PrivateRoute
        path="/safety"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={SafetyView}
            layout={MainLayout}
          />
        )}
      />                
      <Route
        path="/not-found"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={NotFoundView}
            layout={MinimalLayout}
          />
        )}
      />     
      <PrivateRoute
        path="/map"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={MapView}
            layout={NoneLayout}
          />
        )}
      /> 
    </Switch>
  );
};

export default Routes;
